<div class="language-modal">
  <h1 mat-dialog-title class="title-painel" [translate]="'language-modal/choose'"> Choose your language</h1>

  <div class="container">
    <div class="row">
      <app-loading-bar *ngIf="loading" style="margin:auto;text-align: center;"></app-loading-bar>

      <div class="language-container" *ngIf="!loading">
        <button *ngFor="let lang of languages; let i = index" class="language-box language-item menu" (click)="useLanguage(i)">
          <span ngClass="flag-icon flag-icon-{{ lang.flag }}"></span>
          <span>{{lang.name}}</span>
        </button>
      </div>
    </div>
  </div>
</div>